import React from 'react';
import ReactDOM from 'react-dom';
import AddBlock from './addblock';
import BuilderStore from './store/builderStore';
import ShowBuilderPreview from '../preview/showBuilderPreview';
import GridStore from '../panel/store/gridStore';
import SettingStore from './store/settingStore';

export default () => {
  class ReactiveBuilder extends React.Component {
    constructor(props) {
      super(props);
      this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
      window.mkey = this.metakey;
      let dummy;
      if (REBUILDER.hasOwnProperty(this.metakey)) {
        dummy = {
          Reactive: REBUILDER[this.metakey].hasOwnProperty('layoutData') ? REBUILDER[this.metakey].layoutData : [],
          Preview: REBUILDER[this.metakey].hasOwnProperty('previewData') ? REBUILDER[this.metakey].previewData : [],
          Helper: REBUILDER[this.metakey].hasOwnProperty('helperData') ? REBUILDER[this.metakey].helperData : [],
          Settings: REBUILDER[this.metakey].hasOwnProperty('settingsData') ? REBUILDER[this.metakey].settingsData : {},
        };
      }
      this.state = {
        ...dummy,
        isEditable: API.isEditable ? true : false,
      };
      this.storeAddLayout = this.storeAddLayout.bind(this);
      this.storeSettings = this.storeSettings.bind(this);
      this.switchAdmin = this.switchAdmin.bind(this);
      this.isEditable = API.isEditable ? true : false;
    }
    componentDidMount() {
      BuilderStore.listen(this.storeAddLayout);
      GridStore.listen(this.storeAddLayout);
      SettingStore.listen(this.storeSettings);
    }
    switchAdmin(e) {
      e.preventDefault();
      // console.log('called');
      const flag = this.state.isEditable;
      this.setState({ isEditable: !flag });
    }
    storeSettings(settings) {
      if (settings.hasOwnProperty(this.props.shortcodeKey)) {
        if ('settingsData' in settings[this.props.shortcodeKey]) {
          this.setState({
            Helper: settings[this.props.shortcodeKey].helperData,
            Settings: settings[this.props.shortcodeKey].settingsData,
            Preview: settings[this.props.shortcodeKey].previewData,
          });
        }
      }
    }
    storeAddLayout(layout) {
      if (layout.hasOwnProperty(this.props.shortcodeKey)) {
        if ('layoutData' in layout[this.props.shortcodeKey]) {
          this.setState({
            Reactive: layout[this.props.shortcodeKey].layoutData,
            Preview: layout[this.props.shortcodeKey].previewData,
            Helper: layout[this.props.shortcodeKey].helperData,
          });
        }
      }
    }
    render() {
      ReactiveFanoutData.helperData = this.state.Helper;
      return (
        <div>
          {this.isEditable ? <a className="rq-switch-link" href="#" onClick={this.switchAdmin}><span>{API.LANG.REACTIVE_PREVIEW_BUTTON}</span></a> : null}
          <AddBlock {...this.props} isEditable={this.state.isEditable} allLayout={this.state.Reactive} helperData={this.state.Helper} settingsData={this.state.Settings} />
          { this.state.Reactive.length ?
          <ShowBuilderPreview {...this.props}
            allLayout={this.state.Reactive}
            helperData ={this.state.Helper}
            previewData={this.state.Preview}
            settingsData={this.state.Settings}
            isEditable={this.state.isEditable}
          /> : null }
        </div>
      );
    }
  }

  ReactiveBuilder.propTypes = {
    'shortcodeKey': React.PropTypes.number,
    'prevLayout': React.PropTypes.array,
  };

  const allBuilder = jQuery('.reactive-gsb');
  if (allBuilder) {
    window.openWindow = {};
    jQuery(allBuilder).each((index, builder) => {
      const key = jQuery(builder).data('key');
      const panel = 'panel_' + key;
      window.openWindow[panel] = false;
      if (key) {
        ReactDOM.render(<ReactiveBuilder shortcodeKey={key} />, builder);
      }
    });
  }
};



// WEBPACK FOOTER //
// ./assets/src/frontend/builder/re-builder.js